<template>
  <v-container>
    <v-row justify="space-between" dense>
      <v-row align="start" justify="center">
        <v-col cols="12">
          <v-card class="elevation-2">
            <title-bar></title-bar>
            <v-card-title class="primary--text text-h6 pl-4 font-weight-bold"
              >EDUCATION</v-card-title
            >
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <span
                  v-for="(level, index) in {
                    hs: 'High School',
                    co: 'College Or Trade School',
                    ot: 'Other',
                  }"
                  :key="index"
                >
                  <v-card
                    class="mb-3 grey--text"
                    v-if="
                      index == 'hs' ||
                      (index == 'co' && edu['hs'].name) ||
                      (index == 'ot' && edu['co'].name)
                    "
                  >
                    <v-card-title class="text-subtitle-h6 font-weight-bold">{{
                      level
                    }}</v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="edu[index].name"
                            prepend-inner-icon="mdi-school-outline"
                            :label="
                              index == 'hs' ? 'School Name *' : 'School Name'
                            "
                            :rules="index == 'hs' ? requiredRules : []"
                            filled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                          <v-text-field
                            v-model="edu[index].location"
                            :label="
                              index == 'hs' ? 'City, State *' : 'City, State'
                            "
                            :rules="index == 'hs' ? requiredRules : []"
                            filled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                          <v-text-field
                            v-model="edu[index].years"
                            :label="
                              index == 'hs'
                                ? '# of Years Completed *'
                                : '# of Years Completed'
                            "
                            :rules="index == 'hs' ? requiredRules : []"
                            filled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                          <v-text-field
                            v-model="edu[index].gpa"
                            :label="index == 'hs' ? 'GPA *' : 'GPA'"
                            :rules="index == 'hs' ? requiredRules : []"
                            filled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="4" md="2">
                          <v-checkbox
                            v-model="edu[index].finished"
                            label="Degree/Diploma"
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </span>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="secondary" @click="previous">Previous</v-btn>
              <v-btn class="mr-5" color="primary" @click="formSubmit"
                >Next</v-btn
              >
            </v-card-actions>
            <footer-bar></footer-bar>
          </v-card>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import TitleBar from "../components/TitleBar";
import FooterBar from "../components/Footer";

export default {
  components: { TitleBar, FooterBar },

  computed: {
    edu: {
      get() {
        return this.$store.state.edu;
      },
      set(value) {
        this.$store.commit("setEdu", { edu: value });
      },
    },
    app_state: {
      get() {
        return this.$store.state;
      },
    },
  },

  data: () => ({
    valid: false,
    loading: true,
    requiredRules: [(v) => !!v || "This field is required"],
  }),
  props: {
    source: String,
  },

  methods: {
    formSubmit(e) {
      console.log(e);
      console.log(JSON.parse(JSON.stringify(this.$store.state)));
      e.preventDefault();
      if (this.$refs.form.validate()) {
        this.$router.push({ name: "P4" });
      }
    },
    previous(e) {
      e.preventDefault();
      this.$router.push({ name: "P2" });
    },
  },

  /* beforeRouteLeave (to, from , next) {
    const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (answer) {
      next()
    } else {
      next(false)
    }
  }*/
};
</script>
